import React from 'react';
import { Container, ContentText } from './content-result-error-style';
import { BaSeIcon } from '@base/react';

const ContentResultError = ({ moduleId }) => {
  const isQuestionnaire = moduleId === 2;

  return (
    <Container>
      <BaSeIcon
        name="exclamation-octagon"
        size="32"
        description="icon-times"
        color="#fff"
      />
      <ContentText>
        <strong>
          Sua {isQuestionnaire ? 'questionário' : 'entrevista'} não foi{' '}
          {isQuestionnaire ? 'enviado' : 'enviada'}
        </strong>
        <p>
          Mas não se preocupe, suas respostas estão salvas. Às vezes isso
          acontece, tente novamente em alguns instantes.
        </p>
      </ContentText>
    </Container>
  );
};

export default ContentResultError;
